import { Component } from '@angular/core';
import { TabsModule } from 'primeng/tabs';
import { ReporteCierreAnualComponent } from '../../componentes/reporte-cierre-anual/reporte-cierre-anual.component';
import { ReporteContratosComponent } from '../../componentes/reporte-contratos/reporte-contratos.component';
import { ReporteSeguimientoClienteComponent } from '../../componentes/reporte-seguimiento-cliente/reporte-seguimiento-cliente.component';
import { ReportePerformanceBudgetComponent } from '../../componentes/reporte-performance-budget/reporte-performance-budget.component';
import { ReporteSeguimientoComponent } from '../../componentes/reporte-seguimiento/reporte-seguimiento.component';

@Component({
    selector: 'app-bandeja-reporte-ventas',
    standalone: true,
    imports: [
        TabsModule,
        ReporteCierreAnualComponent,
        ReporteContratosComponent,
        ReportePerformanceBudgetComponent,
        ReporteSeguimientoClienteComponent,
        ReporteSeguimientoComponent
    ],
    templateUrl: './bandeja-reporte-ventas.component.html',
    styleUrl: './bandeja-reporte-ventas.component.css'
})
export class BandejaReporteVentasComponent {

}
